export const ALL_OTHERS = "ALL_OTHERS";
export const ALL_RAPID_REWARDS = "ALL_RAPID_REWARDS";
export const NO_PREFERENCE = "NO_PREFERENCE";
